<template>
    <div>
       <h4 class="title">個人資料</h4>
       <div class="member_content">
<div v-show="!this.personalForm">
<table class="table table-bordered  table-nonfluid table-responsive">
    <tbody>
        <tr>
            <td>姓名&nbsp;:&nbsp;</td>
            <td>{{personal.org_name}}</td>
        </tr>
        <tr>
            <td>編號&nbsp;:&nbsp;</td>
            <td>{{personal.org_mid}}</td>
        </tr>
        <tr>
            <td>帳號(電子信箱)&nbsp;:&nbsp;</td>
            <td>{{personal.email}}</td>
        </tr>
        <tr>
            <td>聯絡電話&nbsp;:&nbsp;</td>
            <td>{{personal.org_cellphone}}</td>
        </tr>
        <tr>
            <td>註冊日期&nbsp;:&nbsp;</td>
            <td>{{personal.created_at}}</td>
        </tr>
        <tr>
            <td>上個審核日&nbsp;:&nbsp;</td>
            <td>{{personal.validat}}</td>
        </tr>
        <tr>
            <td>地址&nbsp;:&nbsp;</td>
            <td>
            <div v-if="personal.org_country > 0 && personal.org_town">
              {{this.county[personal.org_country].text + this.district[personal.org_country - 1][personal.org_town].text + personal.org_address}}
            </div>
            </td>
        </tr>
        <tr>
            <td><span class="label label-default">點數餘額&nbsp;:&nbsp;</span></td>
            <td colspan="3">{{personal.org_cash}}</td>
        </tr>
        <tr>
            <td><span class="label label-default">志工點數s&nbsp;:&nbsp;</span></td>
            <td colspan="3">{{personal.volunteer_quota}}</td>
        </tr>
        <tr>
            <td><span class="label label-default">活動集寶箱&nbsp;:&nbsp;</span></td>
            <td colspan="3">{{personal.bonus_wallet}} (達成任務可兌換回點數餘額)</td>
        </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="2">
          <button type="button" class="btn btn-success btn-sm" @click="oepnForm()">編輯資料</button>
        </td>
      </tr>
    </tfoot>
</table>
<span class="label label-warning">會員注意事項</span>
<p>
  任何會員若要退出愛幫您，需要將原先之補助與福利扣除後，可以將點數領回。
</p>
</div>
<div v-show="this.personalForm">
<table class="table table-bordered  table-nonfluid table-responsive">
    <tbody>
        <tr>
            <td>姓名&nbsp;:&nbsp;</td>
            <td>
              <input type="text"  v-model="name"/>
            </td>
        </tr>
        <tr>
            <td>編號&nbsp;:&nbsp;</td>
            <td>{{personal.org_mid}}</td>
        </tr>
        <tr>
            <td>帳號(電子信箱)&nbsp;:&nbsp;</td>
            <td>{{personal.email}}</td>
        </tr>
        <tr>
            <td>聯絡電話&nbsp;:&nbsp;</td>
            <td><input type="text" v-model="phone"/></td>
        </tr>
        <tr>
            <td>密碼&nbsp;:&nbsp;</td>
            <td><input type="password" v-model="password"/>(若無需要更正，留空白即可)</td>
        </tr>
        <tr>
            <td>密碼確認&nbsp;:&nbsp;</td>
            <td><input type="password" v-model="password2"/></td>
        </tr>
        <tr>
            <td>地址&nbsp;:&nbsp;</td>
            <td>
              <div v-if="personal.org_country > 0 && personal.org_town >= 0">
                {{this.county[personal.org_country].text + this.district[personal.org_country - 1][personal.org_town].text + personal.org_address}}
              </div>
            </td>
        </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="2">
          <button type="button" class="btn btn-info btn-sm" @click="editPersonal()">確認編輯</button>
          <button type="button" class="btn btn-default btn-sm" @click="cancel()">取消</button>
        </td>
      </tr>
    </tfoot>
</table>
</div>
      </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'Personal',
  data () {
    return {
      memberurl: this.$store.getters.getMemberAPI,
      userID: this.$store.getters.getUserID,
      token: '',
      apiurl: 'https://affiliate.i80.com.tw/',
      county: this.$store.getters.getCounty,
      district: this.$store.getters.getDistrict,
      phone: '',
      name: '',
      password: '',
      password2: '',
      personal: '',
      email: '',
      personalForm: false
    }
  },
  mounted: function () {
    this.token = this.$store.getters.getToken
    this.phone = this.$store.getters.getUserPhone
    this.name = this.$store.getters.getUserName
    this.email = this.$store.getters.getEmail
    // let id = this.userID

    this.$http.get(this.memberurl + '/member_personal_info', {
      params: {
        token: this.token
      }
    }).then(function (res) {
      let data = res.body.data
      this.personal = data
    }, function () {
      console.log('failed')
    })
  },
  methods: {
    ...mapActions([
      'GET_NEWS'
    ]),
    oepnForm () {
      this.personalForm = true
    },
    editPersonal () {
      let name = this.name
      let phone = this.phone
      let email = this.email
      let password = this.password
      let password2 = this.password2
      if (password !== password2 || password === '' && password2 !== '' || password !== '' && password2 === '') {
        window.alert('兩次密碼輸入不同，請確認後再送出')
      } else if (name === '' || phone === '') {
        window.alert('帳號與手機不得為空。')
      } else {
        this.$http.post(this.apiurl + 'api/updateUser', {
          name: name,
          id: this.userID,
          phone: phone,
          password: password,
          email: email,
          token: this.token
        }).then(function (res) {
          let data = res.body.data
          if (data.status === 200) {
            let setData = {
              userName: data.name,
              userPhone: data.phone
            }
            this.$store.dispatch('UPDATEUSER', setData)
            window.alert('更新成功')
            this.personalForm = false
          } else {
            window.alert('更新失敗')
          }
        }, function () {
          console.log('failed')
        })
      }
    },
    cancel () {
      this.personalForm = false
    }
  },
  computed: {
    ...mapGetters([
      'getCounty',
      'getDistrict',
      'getUserPhone',
      'getUserName'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// Personal.vue?39d5ea72